import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["ellipsis-text-content", { 'is-hidden': !$setup.state }]),
      style: _normalizeStyle({ '--show-lines': $props.lines }),
      ref: "el"
    }, [
      _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps($setup.bounded)))
    ], 6),
    ($setup.isShowButton)
      ? _renderSlot(_ctx.$slots, "action", _normalizeProps(_mergeProps({ key: 0 }, $setup.bounded)))
      : _createCommentVNode("", true)
  ], 64))
}